// App.js
import React, { useEffect, useState } from "react";
import VideoDisplay from "../../components/VideoDisplay/VideoDisplay";
import Assistant from "../../components/Assistant/Assistant";
import Chatbox from "../../components/Chatbox/Chatbox";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import * as Api from "../../constant/Api";
import { db } from "../../firebase";
import {
  collection,
  doc,
  addDoc,
  updateDoc,
  getDocs,
} from "firebase/firestore";
import { AuthContext } from "../../auth/auth";
import { toast } from "react-toastify";
import classes from "./Home.module.css";
import { generateAudio } from "../../constant/Api";

function Home() {
  const { user, logOut, loading } = React.useContext(AuthContext);
  const [data, setData] = useState([]);
  const [videoStatus, setVideoStatus] = useState();
  const [inputText, setInputText] = useState("");
  const [responseText, setResponseText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingVideo, setIsLoadingVideo] = useState(false);
  const [loadingText, setLoadingText] = useState("");
  const [videoLink, setVideoLink] = useState("");
  const [refreshKey, setRefreshKey] = useState(1);
  const [currentAudio, setCurrentAudio] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const assistantId = "asst_9QT83vXhgpENjEFgiRkw0Kxi";
  const apiKey = process.env.REACT_APP_OPEN_KEY; // Replace with your actual OpenAI API key

  const storeData = async ({ videoData, text, id }) => {
    try {
      let objData;
      if (videoData && id) {
        objData = {
          link: videoData["video_url"],
          duration: videoData.duration,
        };
        const docRef = await updateDoc(doc(db, "todos", id), objData);
        if(user){
          fetchPost();
        }
        if (!user && data.length > 0) {
          const index = data.findIndex((item) => item.id === id);
          if (index !== -1) {
            const updatedItems = [...data];
            updatedItems[index] = {
              ...updatedItems[index],
              link: videoData["video_url"],
            };
            setData(updatedItems);
          }
        }

        toast.success("Document stored in database");
      } else if (text) {
        objData = {
          Prompt: text,
          link: "",
          duration: "",
          input: inputText,
        };
        const docRef = await addDoc(collection(db, "todos"), objData);
        toast.success("Document stored in database");
        if (!user) {
          const userObj = {
            Prompt: text,
            link: "",
            duration: "",
            input: inputText,
            id: docRef?.id,
          };
          setData([...data, userObj]);
        }
        if(user){
          fetchPost();
        }
        generate(text, docRef?.id);
      } else {
        toast.error("there is no link");
      }
    } catch (e) {
      toast.error("Error adding document");
      console.error("Error adding document: ", e);
    }
  };

  useEffect(() => {
    if (user) {
      setRefreshKey((prevKey) => prevKey + 1);
    }
  }, [data]);

  const listMessages = async (thread_id) => {
    setLoadingText("Getting message");
    try {
      const response = await fetch(
        `https://api.openai.com/v1/threads/${thread_id}/messages
`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`,
            "OpenAI-Beta": "assistants=v1",
          },
        }
      );

      const data = await response.json();
      if (response.status === 401) {
        toast.error(data.error.message);
        setIsLoading(false);
        return;
      }
      setResponseText(data.data[0].content[0].text.value);

      if (data.data[0].content[0].text.value) {
        storeData({ text: data.data[0].content[0].text.value });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching response:", error);
    }
  };

  const checkStatus = async (thread_id, run_id) => {
    try {
      const response = await fetch(
        `
          https://api.openai.com/v1/threads/${thread_id}/runs/${run_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`,
            "OpenAI-Beta": "assistants=v1",
          },
        }
      );

      const data = await response.json();
      if (response.status === 401) {
        toast.error(data.error.message);
        setIsLoading(false);
        return;
      }
      setLoadingText(`Status: ${data.status}`);
      return data.status;
    } catch (error) {
      console.error("Error fetching response:", error);
    }
  };

  const runThread = async (thread_id) => {
    setLoadingText("Running thread");
    try {
      const response = await fetch(
        `
        https://api.openai.com/v1/threads/${thread_id}/runs`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`,
            "OpenAI-Beta": "assistants=v1",
          },
          body: JSON.stringify({ assistant_id: assistantId }),
        }
      );

      const data = await response.json();
      if (response.status === 401) {
        toast.error(data.error.message);
        setIsLoading(false);
        return;
      }
      const intervalId = setInterval(async () => {
        const status = await checkStatus(thread_id, data.id);
        if (status === "completed") {
          clearInterval(intervalId);
          // Once completed, retrieve messages
          await listMessages(thread_id);
        }
      }, 5000); // Check every 5 seconds
      //listMessages(thread_id);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching response:", error);
    }
  };

  const createThreadMessage = async (thread_id) => {
    setLoadingText("creating thread messages");
    try {
      const response = await fetch(
        `
        https://api.openai.com/v1/threads/${thread_id}/messages`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`,
            "OpenAI-Beta": "assistants=v1",
          },
          body: JSON.stringify({
            role: "user",
            content: inputText,
          }),
        }
      );

      const data = await response.json();
      if (response.status === 401) {
        toast.error(data.error.message);
        setIsLoading(false);
        return;
      }
      runThread(thread_id);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching response:", error);
      toast.error("error fetching response");
    }
  };

  const createThread = async () => {
    setIsLoading(true);
    setLoadingText("Creating Thread");
    try {
      const response = await fetch(
        `
          https://api.openai.com/v1/threads`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`,
            "OpenAI-Beta": "assistants=v1",
          },
        }
      );
      if (response.status === 401) {
        toast.error(response.status);
        setIsLoading(false);
        return;
      }

      const data = await response.json();
      createThreadMessage(data.id);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching response:", error);
      toast.error("Error fetching response");
    }
  };

  const generateVideo = async (promptText, id) => {
    setIsLoadingVideo(true);
    setLoadingText("Creating session");
    const avatar = "1079c4dccd4b47a1854c46d727e070d3";
    const voice = "0152c5821a3140a4b48d609ba6642682";
    if (promptText === "") {
      setLoadingText("Please ask assistance first");
      setIsLoadingVideo(false);

      return;
    }
    const text = promptText;

    try {
      const newSessionInfo = await Api.startGenerate(avatar, voice, text);
      if (!newSessionInfo) {
        setIsLoadingVideo(false);
        return;
      }
      if (newSessionInfo) {
        const intervalId = setInterval(async () => {
          const getVideoStatus = await getStatus(newSessionInfo.video_id, id);
          if (!getVideoStatus) {
            setIsLoadingVideo(false);
            return;
          }
          setLoadingText(getVideoStatus.status);
          console.log("test", getVideoStatus);
          if (getVideoStatus.status === "completed") {
            clearInterval(intervalId);
            setIsLoadingVideo(false);
          }
        }, 10000); // Check every 10 seconds
      }
    } catch (e) {
      toast.error("something went wrong", e.message);
      setIsLoadingVideo(false);
    }
  };

  const getStatus = async (id, docId) => {
    const newSessionInfo = await Api.generateStatus(id);
    setVideoStatus(newSessionInfo);
    if (newSessionInfo.video_url) {
      storeData({ videoData: newSessionInfo, id: docId });
      setVideoLink(newSessionInfo["video_url"]);
    }
    return newSessionInfo;
  };

  const onSetLink = (el) => {
    if (el.link === "") {
      generateVideo(el.Prompt, el.id);
    } else {
      setVideoLink(el.link);
    }
  };

  const fetchPost = async () => {
    await getDocs(collection(db, "todos")).then((querySnapshot) => {
      const newData = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setData(newData);
    });
  };
  const generate = async (Prompt, id) => {
    // Stop the current audio if it exists
    if (currentAudio && !currentAudio?.paused) {
      currentAudio.pause();
      setCurrentAudio(null);
      return;
    }
    if (currentAudio) {
      currentAudio.pause();
      setCurrentAudio(null);
    }
    setLoadingText("Getting Voice");
    setIsLoading(true);
    const url = await generateAudio(Prompt);
    setIsLoading(false);
    const audio = new Audio(url);
    audio.play();
    setCurrentAudio(audio); // Set the current audio element
    setSelectedItem(id);
  };

  useEffect(() => {
    if (user) {
      fetchPost();
    } else if (!user) {
      setData([]);
    }
  }, [user]);
  return (
    <>
      <div className={classes.main}>
        <hr />
        <div className={classes.flexContainer}>
          <div className={classes.chat}>
            <h2>Chat History</h2>
            <div key={refreshKey}>
              <Chatbox
                setLink={onSetLink}
                data={data}
                currentAudio={currentAudio}
                setCurrentAudio={setCurrentAudio}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
              />
            </div>
            <div className={classes.assistant}>
              <Assistant
                inputText={inputText}
                setInputText={setInputText}
                responseText={responseText}
                setResponseText={setResponseText}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                loadingText={loadingText}
                setLoadingText={setLoadingText}
                createThread={createThread}
              />
            </div>
          </div>
          <div className={classes.stream}>
            <h2>Streamed Avatar</h2>
            <div className={classes.avatarBox}>
              {isLoadingVideo && (
                <Box sx={{ textAlign: "center" }}>
                  <CircularProgress />
                  <p>{loadingText}</p>
                </Box>
              )}
              {videoLink !== "" && <VideoDisplay mediaStream={videoLink} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
